import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  /**
   * Returns an observable that retrieves the prices from the API.
   * @returns An observable that emits the prices.
   */
  public getPrices(): Observable<any> {
    return this.http.get(this.apiService.getPricesUrl());
  }

  /**
   * Returns an observable that retrieves a company's subscription from the API.
   * @param companyUuid The UUID of the company to fetch the subscription for.
   * @returns An observable that emits the subscription.
   */
  public getCompanySubscription(companyUuid: string): Observable<any> {
    return this.http.get(this.apiService.getSubscriptionsUrl(companyUuid));
  }

  /**
   * Returns an observable that subscribes the user to a plan.
   * @param planObj The plan object to subscribe to.
   * @returns An observable that emits the subscription.
   */
  public subscribeToPlan(planObj: any): Observable<any> {
    return this.http.get(this.apiService.getStripePortalSessionUrl(), planObj);
    // return this.http.post(this.apiService.getCheckoutSessionUrl(), planObj);
  }

  /**
   * Update subscription
   * @param planObj The plan object to update.
   * @returns An observable that emits the subscription.
   */
  public updateSubscription(planObj: any): Observable<any> {
    return this.http.post(this.apiService.updateSubscriptionUrl(), planObj);
  }

  /**
   * Returns an observable that gets the invoices for a company.
   * @param companyUuid The UUID of the company to fetch the invoices for.
   * @returns An observable that emits the invoices.
   */
  public getInvoices(companyUuid: string): Observable<any> {
    return this.http.get(this.apiService.getInvoicesUrl(companyUuid));
  }

  /**
   * Get stripe portal session
   * @param companyUuid The UUID of the company to fetch the invoices for.
   */

  public getStripePortalSession(): Observable<any> {
    return this.http.get(this.apiService.getStripePortalSessionUrl());
  }

  /**
   * Get promo code
   * @param code The promo code to fetch the invoices for.
   */
  public getPromoCode(code: string): Observable<any> {
    return this.http.get(this.apiService.getPromoCodeUrl(code));
  }

  public updateSubscriptionStatus(
    companyUuid: string,
    action: 'cancel' | 'pause_collection' | 'resume_collection',
    reason: string,
  ): Observable<any> {
    return this.http.post(this.apiService.updateSubscriptionStatusUrl(), {
      company: { uuid: companyUuid },
      action,
      comment: reason,
    });
  }
}
